<script>
import CustomButton from '@/components(new)/UI/Buttons/CustomButton/CustomButton.vue'

export default {
  components: {
    CustomButton
  },
  props: {
    placeholder: {
      typeof: String,
      required: true
    },
    activePesquisaAvancada: {
      typeof: Boolean,
      required: false
    },
    widthInput: {
      typeof: String,
      required: false,
      default: '100%'
    }
  },
  data () {
    return {
      pesquisaAvancada: false,
      pesquisaSimples: ''
    }
  },
  methods: {
    pesquisar () {
      this.$emit('filtrosPesquisa', this.pesquisaSimples)
    },
    limpar () {
      this.pesquisaSimples = ''
      this.$emit('limpar')
    },
    showPesquisaAvancada () {
      this.pesquisaAvancada = !this.pesquisaAvancada
    }
  }
}
</script>

<template>
  <div class="input-wrapper" :style="'width:' + widthInput">
    <div class="input-container mb-2">
      <input
        type="text"
        :placeholder="placeholder"
        id="filtroSimples"
        v-model="pesquisaSimples"
        @keyup.enter="pesquisar"
      />
      <span class="search-icon" @click="pesquisar"><i class="el-icon-search font-wt-4"></i></span>
    </div>
    <div class="flex-bottom gap-3">
      <slot name="filtros"></slot>
      <CustomButton type="OutlinedButton" text="Filtrar" @click="pesquisar" />
      <CustomButton type="IconButton" text="Limpar" @click="limpar" />
    </div>
  </div>

</template>

<style lang="scss" scoped>
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Filters/FiltroGenerico/FiltroGenerico.vue